/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
// import { throttle } from 'lodash-es';
// import copyIcon from '@/assets/images/copy.svg';
// import { usePasteHandler } from '@/hooks/usePasteHandler';
// import { useBitKeepContext } from '@/components/BitKeepProvider';
import Spinner from "@/components/Spinner";
export default function SecretCodeForm(param) {
    let { onSubmit, onFormFocus } = param;
    const translationPageKey = "Tomarket_activity";
    const t = useTranslations("");
    // const { bitkeep } = useBitKeepContext();
    const [submitting, setSubmitting] = useState(false);
    const [onInput, setOnInput] = useState(false);
    const [code, setCode] = useState("");
    const [error, setError] = useState(null);
    // const { pasteFromClipboard } = usePasteHandler();
    // const handlePasteClick = throttle(async () => {
    //   const clipboardText = await pasteFromClipboard();
    //   setCode(clipboardText);
    // }, 500);
    //   useClipboard((data: string) => {
    //     setCode(data);
    // });
    // const openTomaLink = async () => {
    //   try {
    //     bitkeep.jumpUrl('');
    //   } catch (error) {
    //     console.error('jumpUrl error', error);
    //   }
    // };
    // Handles the form submission logic
    const handleSubmit = async ()=>{
        if (!code) {
            setError("Code cannot be empty.");
            return;
        }
        if (submitting) {
            return;
        }
        setSubmitting(true);
        const success = await onSubmit(code);
        setSubmitting(false);
        if (success) {
            setError(null);
        } else {
            setError("Wrong code! Try again...");
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "h-full w-full relative",
        children: [
            /*#__PURE__*/ _jsx("label", {
                className: "flex justify-between mb-[12px]",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "text-[14px] font-semibold leading-[22px] text-left",
                    children: t("".concat(translationPageKey, "_secret_code_label"))
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "input-box",
                className: "p-[12px] gap-[12px] rounded-[12px]  border-[1px] border-solid  bg-[#F8F8F9] flex \n        border-[#E9ECEC]\n        outline-none\n        ".concat(onInput ? "border-[#00C2B7] ring-1 ring-[#00C2B7]" : "", "\n        ").concat(error ? "border-[#FE5B79] ring-1 ring-[#FE5B79]" : "", "\n        "),
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    placeholder: t("".concat(translationPageKey, "_secret_code_placeholder")),
                    value: code,
                    onInput: ()=>setError(null),
                    onFocus: ()=>{
                        setOnInput(true);
                        onFormFocus === null || onFormFocus === void 0 ? void 0 : onFormFocus();
                    },
                    onBlur: ()=>setOnInput(false),
                    onChange: (e)=>setCode(e.target.value),
                    className: "flex-1 border-none bg-transparent rounded outline-none"
                })
            }),
            error && /*#__PURE__*/ _jsx("p", {
                className: "mt-[12px] text-[14px] font-normal leading-[22px] text-[#FE5B79]",
                children: error
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute w-full bottom-[34px]",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-[14px] leading-[22px]text-center text-[#515656] text-center",
                        children: t.rich("Tomarket_activity_tips", {
                            red: (chunks)=>/*#__PURE__*/ _jsx("span", {
                                    className: "text-[#FF3F6D]",
                                    children: chunks
                                })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "w-full my-[8px] h-[34px] px-[12px] py-[8px] rounded-tl-[4px] rounded-tr-0 rounded-br-0 rounded-bl-0 bg-[#F8F8F9] text-[#515656] text-[12px] font-normal leading-[18px] text-left",
                        children: [
                            t("".concat(translationPageKey, "_not_found")),
                            " ",
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://t.me/Tomarket_ai_bot/app",
                                className: "underline",
                                children: "Tomarket"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handleSubmit,
                        className: "w-full my-[12px] h-[56px] px-[36px] py-[16px] rounded-[100px] bg-[#000000] text-[#fff] font-semibold text-[16px] leading-[24px] text-center",
                        children: submitting ? /*#__PURE__*/ _jsx(Spinner, {
                            color: "#fff"
                        }) : t("".concat(translationPageKey, "_submit"))
                    })
                ]
            })
        ]
    });
}
